import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationsAnreComponent } from './notifications-anre/notifications-anre.component';
import { SuppliersAnreComponent } from './suppliers-anre/suppliers-anre.component';
import { SuppliersDetailsComponent } from './suppliers-anre/suppliers-details/suppliers-details.component';
import { SuppliersFuiComponent } from './suppliers-anre/suppliers-fui/suppliers-fui.component';
import { OperatorSupplierValidationComponent } from './task-anre/details/operator-supplier-validation/operator-supplier-validation.component';
import { TaskAnreComponent } from './task-anre/task-anre.component';
import { SuppliersLicenceComponent } from './suppliers-anre/suppliers-licence/suppliers-licence.component';
import { OperatorsAnreComponent } from './operators-anre/operators-anre.component';
import {PosfFixComponent} from './posf-fix/posf-fix.component';
import {MessagesComponent} from './messages/messages.component';
import {MessagesDetailsComponent} from './messages/messages-details/messages-details.component';
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'date-identificare',
        component: PosfFixComponent,
        data: {
          breadcrumb: "Date identificare"
        }
      },
      {
        path: 'task-uri',
        component: TaskAnreComponent,
        data: {
          breadcrumb: "Task-uri"
        }
      },
      {
        path: 'task-validare',
        component: OperatorSupplierValidationComponent,
        data: {
          breadcrumb: "Task-uri"
        }
      },
      {
        path: 'notificari',
        component: NotificationsAnreComponent,
        data: {
          breadcrumb: "Notificari"
        }
      },
      {
        path: 'mesaje',
        component: MessagesComponent,
        data: {
          breadcrumb: 'Mesaje'
        }
      },
      {
        path: 'mesaje-detalii',
        component: MessagesDetailsComponent,
        data: {
          breadcrumb: 'Detalii Mesaje'
        }
      },
      {
        path: 'furnizori',
        component: SuppliersAnreComponent,
        data: {
          breadcrumb: "Furnizori"
        }
      },
      {
        path: 'furnizor-fui',
        component: SuppliersFuiComponent,
        data: {
          breadcrumb: "Furnizori"
        }
      },
      {
        path: 'licenta-furnizor',
        component: SuppliersLicenceComponent,
        data: {
          breadcrumb: "Furnizori"
        }
      },
      {
        path: 'furnizor-detalii',
        component: SuppliersDetailsComponent,
        data: {
          breadcrumb: "Furnizori"
        }
      },
      {
        path: 'operatori',
        component: OperatorsAnreComponent,
        data: {
          breadcrumb: "Operatori"
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnreRoutingModule { }
